var _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimLotteryPrice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 103,
    viewBox: "0 0 112 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.1686,
    cy: 56.0192,
    rx: 47.1686,
    ry: 46.9808,
    fill: "url(#paint0_linear_607_7626)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9843,
    cy: 88.7591,
    rx: 6.64347,
    ry: 6.61702,
    fill: "#3C37FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.589,
    cy: 50.7403,
    rx: 18.6017,
    ry: 18.5277,
    fill: "#FFBC00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1611 50.5421C42.9347 47.3164 44.0713 42.3519 44.0713 36.7839C44.0713 36.2694 44.0618 35.7606 44.0428 35.2576H49.1732C49.1547 35.7606 49.1452 36.2694 49.1447 36.7839C49.1447 42.3519 50.2813 47.3164 52.0549 50.5421H41.1611Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1474 36.7839C49.1474 36.2694 49.1569 35.7606 49.1759 35.2576H44.0454C44.064 35.7606 44.0735 36.2694 44.0739 36.7839C44.0739 37.7765 44.0369 38.7499 43.9678 39.6976C43.9678 39.6976 46.4375 38.1862 49.2565 39.6976C49.1838 38.7499 49.1474 37.7765 49.1474 36.7839Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3224 35.2576H44.5849C44.5996 35.7606 44.6072 36.2694 44.6077 36.7839C44.6077 42.3519 43.7113 47.3164 42.3125 50.5421H43.8801C44.7687 47.3164 45.3388 42.3519 45.3388 36.7839C45.3378 36.2694 45.3324 35.7606 45.3224 35.2576Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0582 50.5421H49.3397C48.4512 47.3164 47.8818 42.3519 47.8818 36.7839C47.8818 36.2694 47.8866 35.7606 47.8961 35.2576H49.1787C49.1602 35.7606 49.1507 36.2694 49.1502 36.7839C49.1481 42.3519 50.2846 47.3164 52.0582 50.5421Z",
    fill: "#F8B805"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5552 32.1929H39.5488C35.5414 32.1772 32.4595 31.8715 29.8501 31.2302C26.7226 30.4614 24.2365 29.1916 22.2491 27.3474C17.9887 23.3948 16.0049 16.7594 16.0049 6.46492C16.0047 6.24356 16.0493 6.02446 16.1361 5.82083C16.2229 5.6172 16.35 5.43325 16.5098 5.2801C16.6696 5.12694 16.8588 5.00775 17.066 4.9297C17.2731 4.85166 17.4939 4.81639 17.715 4.82601C17.8412 4.83171 30.4094 5.38253 39.479 4.96853C39.7001 4.9589 39.9209 4.99418 40.1281 5.07222C40.3352 5.15026 40.5244 5.26946 40.6842 5.42261C40.844 5.57577 40.9712 5.75971 41.058 5.96334C41.1447 6.16698 41.1894 6.38608 41.1892 6.60743V30.554C41.1892 30.9887 41.0165 31.4055 40.7091 31.7129C40.4018 32.0202 39.9849 32.1929 39.5503 32.1929H39.5552ZM19.3012 8.17009C19.495 16.5071 21.1539 21.8607 24.478 24.9447C27.225 27.4935 31.2944 28.7006 37.9156 28.8894V8.30976C31.0173 8.53279 22.8128 8.2955 19.3012 8.17009Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7926 6.65864C20.5944 6.65152 20.3969 6.6854 20.2125 6.75816C20.028 6.83091 19.8606 6.94098 19.7206 7.08146C19.5807 7.22194 19.4713 7.3898 19.3992 7.57454C19.3272 7.75928 19.294 7.9569 19.3019 8.15504V8.17071C22.842 8.29612 31.0529 8.53198 37.9163 8.31323V6.74843C31.8631 6.94367 24.8029 6.78477 20.7926 6.65864Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.917 28.888V28.489C37.9504 28.691 37.9526 28.8283 37.917 28.888Z",
    fill: "#F8B805"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3016 8.1543L19.3387 8.17069H19.3016C19.4955 16.5077 21.1543 21.8613 24.4784 24.9452C27.2254 27.4941 31.2949 28.7012 37.916 28.89C37.4529 29.6738 34.81 29.2755 34.81 29.2755C16.9103 29.0518 19.3016 8.1543 19.3016 8.1543Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1491 30.8098V6.86256C41.1493 6.64121 41.1046 6.42211 41.0178 6.21847C40.9311 6.01484 40.8039 5.8309 40.6441 5.67774C40.4843 5.52459 40.2951 5.40539 40.088 5.32735C39.8808 5.24931 39.66 5.21403 39.4389 5.22366C30.37 5.63908 17.8018 5.08827 17.6756 5.08114C17.2994 5.06437 16.9288 5.17771 16.6263 5.4021C16.3238 5.62648 16.1078 5.94822 16.0146 6.31317C16.0531 5.89364 16.2516 5.50501 16.569 5.22796C16.8863 4.95091 17.2982 4.80672 17.7191 4.82533C17.8452 4.83103 30.4135 5.38185 39.4831 4.96784C39.7042 4.95822 39.925 4.99349 40.1322 5.07154C40.3393 5.14958 40.5285 5.26877 40.6883 5.42193C40.8481 5.57509 40.9752 5.75903 41.062 5.96266C41.1488 6.16629 41.1934 6.3854 41.1932 6.60675V30.554C41.193 30.6905 41.176 30.8264 41.1426 30.9588C41.1469 30.9096 41.1491 30.8597 41.1491 30.8098Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6228 31.5586C37.9544 31.5686 39.2844 31.6523 40.6067 31.8094C40.312 32.0567 39.9397 32.1924 39.555 32.1927H39.5486C35.5411 32.1771 32.4592 31.8714 29.8498 31.2301C26.7224 30.4612 24.2362 29.1914 22.2489 27.3473C20.0128 25.2723 18.401 22.4584 17.3799 18.7644C19.1884 24.2441 23.9719 31.4111 36.6228 31.5586Z",
    fill: "#F8B805"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5068 31.715C52.354 31.5627 52.2327 31.3819 52.1499 31.1827C52.0671 30.9835 52.0245 30.7699 52.0244 30.5542V6.60621C52.0242 6.38486 52.0688 6.16576 52.1556 5.96212C52.2424 5.75849 52.3695 5.57455 52.5294 5.42139C52.6892 5.26823 52.8784 5.14904 53.0855 5.071C53.2926 4.99295 53.5134 4.95768 53.7346 4.96731C62.8041 5.38273 75.3724 4.83192 75.4985 4.82479C75.7197 4.81517 75.9405 4.85044 76.1476 4.92848C76.3548 5.00653 76.5439 5.12572 76.7038 5.27888C76.8636 5.43203 76.9907 5.61598 77.0775 5.81961C77.1643 6.02324 77.2089 6.24234 77.2087 6.4637C77.2087 16.7582 75.2249 23.3936 70.9645 27.3462C68.9771 29.1903 66.491 30.4601 63.3635 31.229C60.7541 31.8703 57.6722 32.176 53.6647 32.1917H53.6583C53.2267 32.1906 52.8129 32.0193 52.5068 31.715ZM55.3022 8.30996V28.8896C61.9234 28.7008 65.9907 27.4937 68.7405 24.9449C72.064 21.8609 73.7228 16.5073 73.9166 8.1703C70.4051 8.29571 62.1977 8.53299 55.3008 8.30996H55.3022Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3008 6.74855V8.30978C62.1642 8.53139 70.3751 8.29553 73.9152 8.16727V8.15159C73.9231 7.95352 73.89 7.75596 73.818 7.57127C73.7459 7.38658 73.6366 7.21875 73.4967 7.07828C73.3568 6.93781 73.1895 6.82773 73.0051 6.75493C72.8207 6.68213 72.6233 6.64818 72.4252 6.6552C68.4149 6.78489 61.3548 6.94379 55.3008 6.74855Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.301 28.888V28.489C55.2676 28.691 55.2661 28.8283 55.301 28.888Z",
    fill: "#F8B805"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9159 8.1543L73.8788 8.17069H73.9152C73.7214 16.5077 72.0625 21.8613 68.7391 24.9452C65.9914 27.4941 61.922 28.7012 55.3008 28.89C55.764 29.6738 58.4069 29.2755 58.4069 29.2755C76.3066 29.0518 73.9159 8.1543 73.9159 8.1543Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0676 30.8098V6.86256C52.0674 6.64121 52.112 6.42211 52.1988 6.21847C52.2856 6.01484 52.4127 5.8309 52.5726 5.67774C52.7324 5.52459 52.9216 5.40539 53.1287 5.32735C53.3358 5.24931 53.5566 5.21403 53.7778 5.22366C62.8466 5.63908 75.4156 5.08827 75.541 5.08114C75.9173 5.06437 76.2879 5.17771 76.5904 5.4021C76.8929 5.62648 77.1089 5.94822 77.202 6.31317C77.1636 5.89364 76.9651 5.50501 76.6477 5.22796C76.3303 4.95091 75.9184 4.80672 75.4976 4.82533C75.3714 4.83103 62.8032 5.38185 53.7336 4.96784C53.5125 4.95822 53.2917 4.99349 53.0845 5.07154C52.8774 5.14958 52.6882 5.26877 52.5284 5.42193C52.3686 5.57509 52.2414 5.75903 52.1546 5.96266C52.0679 6.16629 52.0232 6.3854 52.0234 6.60675V30.554C52.0236 30.6905 52.0408 30.8265 52.0747 30.9588C52.0699 30.9093 52.0675 30.8596 52.0676 30.8098Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5943 31.5587C55.2628 31.5678 53.9327 31.6506 52.6104 31.8067C52.9051 32.054 53.2774 32.1897 53.6621 32.1901H53.6685C57.676 32.1744 60.7578 31.8687 63.3673 31.2274C66.4947 30.4585 68.9809 29.1887 70.9682 27.3446C73.2043 25.2696 74.8161 22.4557 75.8372 18.7617C74.0266 24.2442 69.2452 31.4112 56.5943 31.5587Z",
    fill: "#F8B805"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0463 0C27.5862 2.65925 27.3564 5.35325 27.3594 8.05202C27.3594 24.7881 35.9729 38.3554 46.5987 38.3554C57.2245 38.3554 65.8381 24.7881 65.8381 8.05202C65.8411 5.35325 65.6113 2.65925 65.1511 0H28.0463Z",
    fill: "#F8B805"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0463 0C27.5862 2.65925 27.3564 5.35325 27.3594 8.05202C27.3594 24.7881 35.9729 38.3554 46.5987 38.3554C57.2245 38.3554 65.8381 24.7881 65.8381 8.05202C65.8411 5.35325 65.6113 2.65925 65.1511 0H28.0463Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1519 0H58.2165C58.5049 2.67427 58.6476 5.36224 58.6441 8.05202C58.6441 24.7881 53.2506 38.3554 46.5967 38.3554C57.2225 38.3554 65.836 24.7881 65.836 8.05202C65.84 5.35333 65.6111 2.65934 65.1519 0Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8698 9.93066L49.3909 15.0391L55.0287 15.8585L50.9493 19.8354L51.9127 25.4504L46.8698 22.7989L41.827 25.4504L42.7904 19.8354L38.7109 15.8585L44.3488 15.0391L46.8698 9.93066Z",
    fill: "#F7A108"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5507 8.05421C34.5472 5.36444 34.6899 2.67647 34.9783 0.00219727H30.2383C29.8315 2.66685 29.6287 5.35868 29.6319 8.05421C29.634 24.7896 37.2286 38.3576 46.5995 38.3576C39.9456 38.3576 34.5507 24.7896 34.5507 8.05421Z",
    fill: "#F8B805"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5982 9.28463C34.832 9.28463 36.6428 7.47383 36.6428 5.24009C36.6428 3.00636 34.832 1.19556 32.5982 1.19556C30.3645 1.19556 28.5537 3.00636 28.5537 5.24009C28.5537 7.47383 30.3645 9.28463 32.5982 9.28463Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6414 10.8877C37.5268 10.8877 38.2446 10.1699 38.2446 9.28443C38.2446 8.39896 37.5268 7.68115 36.6414 7.68115C35.7559 7.68115 35.0381 8.39896 35.0381 9.28443C35.0381 10.1699 35.7559 10.8877 36.6414 10.8877Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3328 0.597844C56.4313 0.597844 64.618 0.329919 64.618 0H28.0469C28.0469 0.329919 36.2336 0.597844 46.3328 0.597844Z",
    fill: "#F8B805"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3811 50.5422H38.8378C38.3498 50.5421 37.8665 50.6382 37.4156 50.8249C36.9646 51.0116 36.5549 51.2853 36.2097 51.6304C35.8646 51.9755 35.5908 52.3852 35.404 52.836C35.2172 53.2869 35.1211 53.7702 35.1211 54.2583H58.0971C58.0971 53.7703 58.001 53.2871 57.8143 52.8362C57.6275 52.3854 57.3538 51.9757 57.0087 51.6306C56.6637 51.2856 56.254 51.0119 55.8032 50.8251C55.3523 50.6384 54.8691 50.5422 54.3811 50.5422Z",
    fill: "#F8B805"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8378 50.8209H54.3811C55.3184 50.8207 56.2212 51.1749 56.9083 51.8124C57.5955 52.4499 58.0163 53.3236 58.0864 54.2583H58.0978C58.0978 53.2727 57.7063 52.3275 57.0094 51.6306C56.3125 50.9337 55.3674 50.5422 54.3818 50.5422H38.8378C38.3498 50.5421 37.8665 50.6382 37.4156 50.8249C36.9646 51.0116 36.5549 51.2853 36.2097 51.6304C35.8646 51.9755 35.5908 52.3852 35.404 52.836C35.2172 53.2869 35.1211 53.7702 35.1211 54.2583H35.1325C35.2028 53.3236 35.6236 52.4501 36.3108 51.8126C36.9979 51.1752 37.9006 50.8209 38.8378 50.8209Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0962 54.2583H53.9398C53.9398 52.2061 52.8781 50.5422 51.5684 50.5422H54.3801C55.3657 50.5422 56.3109 50.9337 57.0078 51.6306C57.7047 52.3275 58.0962 53.2727 58.0962 54.2583Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4263 50.5422H40.3623C39.8742 50.5421 39.3909 50.6382 38.94 50.8249C38.489 51.0116 38.0793 51.2853 37.7342 51.6304C37.389 51.9755 37.1152 52.3852 36.9284 52.836C36.7416 53.2869 36.6455 53.7702 36.6455 54.2583H39.7138C39.7138 53.2733 40.1048 52.3287 40.801 51.6319C41.4971 50.9351 42.4414 50.5432 43.4263 50.5422Z",
    fill: "#F8B805"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0995 54.2585H29.1196C28.9295 54.2585 28.7754 54.4126 28.7754 54.6027V68.1907C28.7754 68.3807 28.9295 68.5348 29.1196 68.5348H64.0995C64.2896 68.5348 64.4437 68.3807 64.4437 68.1907V54.6027C64.4437 54.4126 64.2896 54.2585 64.0995 54.2585Z",
    fill: "#44352A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0995 66.0803H29.1196C29.0283 66.0803 28.9407 66.044 28.8762 65.9794C28.8117 65.9149 28.7754 65.8274 28.7754 65.7361V68.1902C28.7754 68.2814 28.8117 68.369 28.8762 68.4335C28.9407 68.4981 29.0283 68.5343 29.1196 68.5343H64.0995C64.1447 68.5343 64.1894 68.5254 64.2311 68.5081C64.2728 68.4908 64.3107 68.4655 64.3426 68.4335C64.3745 68.4015 64.3998 68.3636 64.417 68.3218C64.4342 68.2801 64.4431 68.2353 64.443 68.1902V65.7361C64.4431 65.7812 64.4342 65.826 64.417 65.8677C64.3998 65.9095 64.3745 65.9474 64.3426 65.9794C64.3107 66.0114 64.2728 66.0367 64.2311 66.054C64.1894 66.0713 64.1447 66.0803 64.0995 66.0803Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1187 68.5347H31.2721C30.4645 68.5347 29.6681 68.5029 28.8828 68.4392C28.9463 68.5 29.0307 68.5342 29.1187 68.5347Z",
    fill: "#44352A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M64.099 54.2585H53.4048C51.7531 62.3419 42.4726 68.5348 31.2725 68.5348H64.1005C64.1456 68.5348 64.1903 68.5259 64.2321 68.5086C64.2738 68.4913 64.3117 68.466 64.3436 68.434C64.3755 68.402 64.4008 68.3641 64.418 68.3223C64.4352 68.2806 64.444 68.2358 64.4439 68.1907V54.6027C64.444 54.5574 64.4352 54.5126 64.4178 54.4707C64.4005 54.4289 64.3751 54.3909 64.3431 54.3589C64.311 54.3269 64.273 54.3016 64.2311 54.2844C64.1892 54.2671 64.1443 54.2584 64.099 54.2585Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0995 54.2585H29.1196C29.0283 54.2585 28.9407 54.2948 28.8762 54.3593C28.8117 54.4239 28.7754 54.5114 28.7754 54.6027V55.0488C28.7754 54.9575 28.8117 54.87 28.8762 54.8054C28.9407 54.7409 29.0283 54.7046 29.1196 54.7046H64.0995C64.1447 54.7046 64.1894 54.7135 64.2311 54.7308C64.2728 54.7481 64.3107 54.7735 64.3426 54.8055C64.3745 54.8374 64.3998 54.8754 64.417 54.9171C64.4342 54.9589 64.4431 55.0036 64.443 55.0488V54.6027C64.4431 54.5576 64.4342 54.5128 64.417 54.4711C64.3998 54.4293 64.3745 54.3914 64.3426 54.3594C64.3107 54.3274 64.2728 54.3021 64.2311 54.2848C64.1894 54.2675 64.1447 54.2585 64.0995 54.2585Z",
    fill: "#44352A"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7538 66.6941H26.4645C26.2252 66.6941 26.0312 66.8881 26.0312 67.1273V69.2722C26.0312 69.5114 26.2252 69.7054 26.4645 69.7054H66.7538C66.9931 69.7054 67.187 69.5114 67.187 69.2722V67.1273C67.187 66.8881 66.9931 66.6941 66.7538 66.6941Z",
    fill: "#44352A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7538 69.3158H26.4645C26.3496 69.3158 26.2394 69.2702 26.1581 69.1889C26.0769 69.1077 26.0313 68.9975 26.0312 68.8826V69.2716C26.0313 69.3865 26.0769 69.4967 26.1581 69.578C26.2394 69.6592 26.3496 69.7049 26.4645 69.7049H66.7538C66.8687 69.7049 66.9789 69.6592 67.0601 69.578C67.1414 69.4967 67.187 69.3865 67.187 69.2716V68.8826C67.187 68.9975 67.1414 69.1077 67.0601 69.1889C66.9789 69.2702 66.8687 69.3158 66.7538 69.3158Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7538 66.6941H26.4645C26.3496 66.6941 26.2394 66.7397 26.1581 66.821C26.0769 66.9022 26.0312 67.0124 26.0312 67.1273V67.5285C26.0312 67.4136 26.0769 67.3034 26.1581 67.2222C26.2394 67.1409 26.3496 67.0953 26.4645 67.0953H66.7538C66.8687 67.0953 66.9789 67.1409 67.0601 67.2222C67.1414 67.3034 67.187 67.4136 67.187 67.5285V67.1273C67.187 67.0124 67.1414 66.9022 67.0601 66.821C66.9789 66.7397 66.8687 66.6941 66.7538 66.6941Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7536 66.6941H55.2656C55.3805 66.6941 55.4907 66.7397 55.572 66.821C55.6532 66.9022 55.6989 67.0124 55.6989 67.1273V69.2722C55.6989 69.3871 55.6532 69.4973 55.572 69.5785C55.4907 69.6598 55.3805 69.7054 55.2656 69.7054H66.7536C66.8685 69.7054 66.9787 69.6598 67.06 69.5785C67.1412 69.4973 67.1869 69.3871 67.1869 69.2722V67.1273C67.1869 67.0124 67.1412 66.9022 67.06 66.821C66.9787 66.7397 66.8685 66.6941 66.7536 66.6941Z",
    fill: "#44352A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6406 69.2722V67.1273C35.6406 67.0124 35.6862 66.9022 35.7674 66.821C35.8487 66.7397 35.9589 66.6941 36.0738 66.6941H29.8239C29.709 66.6941 29.5988 66.7397 29.5175 66.821C29.4363 66.9022 29.3906 67.0124 29.3906 67.1273V69.2722C29.3906 69.3871 29.4363 69.4973 29.5175 69.5785C29.5988 69.6598 29.709 69.7054 29.8239 69.7054H36.0738C35.9589 69.7054 35.8487 69.6598 35.7674 69.5785C35.6862 69.4973 35.6406 69.3871 35.6406 69.2722Z",
    fill: "#44352A"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2177 56.3638H31.9404V64.9894H61.2177V56.3638Z",
    fill: "#EFCA6F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2177 64.8057H31.9404V64.9895H61.2177V64.8057Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2177 56.3638H31.9404V56.5476H61.2177V56.3638Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1211 54.2582H58.0971C58.0971 54.0338 58.0765 53.8098 58.0359 53.5891H35.1831C35.1422 53.8098 35.1214 54.0338 35.1211 54.2582Z",
    fill: "#F8B805"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7882 56.3638C51.4585 59.8268 48.6937 62.8318 45.0098 64.9894H61.2178V56.3638H52.7882Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 57.9361C33.3689 57.9361 33.5933 57.7117 33.5933 57.4349C33.5933 57.158 33.3689 56.9336 33.0921 56.9336C32.8152 56.9336 32.5908 57.158 32.5908 57.4349C32.5908 57.7117 32.8152 57.9361 33.0921 57.9361Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6023 57.4365C60.6016 57.3381 60.5717 57.2421 60.5166 57.1606C60.4614 57.0791 60.3833 57.0158 60.2921 56.9786C60.201 56.9414 60.1009 56.932 60.0045 56.9517C59.908 56.9713 59.8195 57.019 59.7502 57.0889C59.6808 57.1587 59.6337 57.2475 59.6148 57.3441C59.5958 57.4407 59.6059 57.5407 59.6437 57.6316C59.6816 57.7225 59.7455 57.8001 59.8273 57.8547C59.9092 57.9093 60.0054 57.9385 60.1039 57.9385C60.1696 57.9385 60.2347 57.9255 60.2954 57.9002C60.3561 57.8749 60.4112 57.8379 60.4576 57.7912C60.5039 57.7446 60.5405 57.6892 60.5654 57.6283C60.5902 57.5674 60.6027 57.5022 60.6023 57.4365Z",
    fill: "#EFCA6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1018 64.4119C60.3787 64.4119 60.6031 64.1875 60.6031 63.9107C60.6031 63.6338 60.3787 63.4094 60.1018 63.4094C59.825 63.4094 59.6006 63.6338 59.6006 63.9107C59.6006 64.1875 59.825 64.4119 60.1018 64.4119Z",
    fill: "#EFCA6F"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.054 57.8822C33.3308 57.8822 33.5552 57.6577 33.5552 57.3809C33.5552 57.1041 33.3308 56.8796 33.054 56.8796C32.7772 56.8796 32.5527 57.1041 32.5527 57.3809C32.5527 57.6577 32.7772 57.8822 33.054 57.8822Z",
    fill: "#44352A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0921 64.4066C33.3689 64.4066 33.5933 64.1821 33.5933 63.9053C33.5933 63.6285 33.3689 63.4041 33.0921 63.4041C32.8152 63.4041 32.5908 63.6285 32.5908 63.9053C32.5908 64.1821 32.8152 64.4066 33.0921 64.4066Z",
    fill: "#EFCA6F"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33.054 64.3509C33.3308 64.3509 33.5552 64.1265 33.5552 63.8496C33.5552 63.5728 33.3308 63.3484 33.054 63.3484C32.7772 63.3484 32.5527 63.5728 32.5527 63.8496C32.5527 64.1265 32.7772 64.3509 33.054 64.3509Z",
    fill: "#44352A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1018 57.8822C60.3787 57.8822 60.6031 57.6577 60.6031 57.3809C60.6031 57.1041 60.3787 56.8796 60.1018 56.8796C59.825 56.8796 59.6006 57.1041 59.6006 57.3809C59.6006 57.6577 59.825 57.8822 60.1018 57.8822Z",
    fill: "#44352A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1018 64.3509C60.3787 64.3509 60.6031 64.1265 60.6031 63.8496C60.6031 63.5728 60.3787 63.3484 60.1018 63.3484C59.825 63.3484 59.6006 63.5728 59.6006 63.8496C59.6006 64.1265 59.825 64.3509 60.1018 64.3509Z",
    fill: "#44352A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_607_7626",
    x1: 47.1686,
    y1: 9.03833,
    x2: 47.1686,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28293F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28293F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimLotteryPrice);
export default __webpack_public_path__ + "static/media/claimLotteryPrice.780c5ffbb5a381f45b6b54b40812f384.svg";
export { ForwardRef as ReactComponent };